module.exports = __webpack_public_path__ + "img/zizhi12.c912a764.png";